import { IframeComponents } from 'shared/enums';

export const checkIsOnlineVisit = () => {
  return (
    window.location.href.includes('onlineVisit') ||
    window.location.href.includes('startVisit') ||
    window.location.href.includes(`iframe/${IframeComponents.Visit}`)
  );
};
